import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f37222ae&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37222ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37222ae')) {
      api.createRecord('f37222ae', component.options)
    } else {
      api.reload('f37222ae', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f37222ae&scoped=true&", function () {
      api.rerender('f37222ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o6g5fINOb4IB/JS/comp/Accordion.vue"
export default component.exports